import type { LogsEvent } from '@datadog/browser-logs';

// Datadog 로그 3분류 (PROD-22892) — Teams 에러 알림 노이즈 차단
// 매칭 문자열은 실제 SDK 메시지 포맷 그대로, 대소문자 구분 (e2e/datadog-before-send.spec.ts로 고정)

// 1. Drop: 순수 노이즈 — Datadog 미전송
const DROP_PATTERNS = ['antd: Modal', 'useForm', 'findDOMNode', '[GetSapElementFromHtmlId]', 'g/collect'];

// 2. 경고: 네트워크/요청·로그인 실패 — warn으로 내려 전송은 유지하되 에러 알림에서 제외
const WARN_PATTERNS = ['XHR error', 'Fetch error', 'Login failed', 'AxiosError', 'Request failed with status code'];

// 3. 나머지(실제 런타임 버그)는 그대로 error 유지
export const beforeSendHandler = (log: LogsEvent): boolean => {
  if (log.message) {
    if (DROP_PATTERNS.some((pattern) => log.message.includes(pattern))) {
      return false;
    }
    if (log.status === 'error' && WARN_PATTERNS.some((pattern) => log.message.includes(pattern))) {
      // eslint-disable-next-line no-param-reassign -- beforeSend는 이벤트 객체 in-place 수정이 Datadog 공식 계약
      log.status = 'warn';
    }
  }
  return true;
};
